<template>
  <VueMap
    v-model:coordinate="coordinate"
    v-model:zoom="zoom"
    class="camera-map"
  >
    <VueMapDraggableMarker
      v-if="!hideMarker"
      v-model:coordinate="cameraCoordinate"
      :marker-style="MapMarkerStyle.camera"
      @marker-move="onMarkerMoved"
    />
  </VueMap>
</template>
<script lang="ts" setup>
  import MapCoordinate from '@/Types/mapCoordinate';
  import { Ref } from 'vue';
  import VueMap from '@/VueComponents/SharedComponents/Map/VueMap.vue';
  import VueMapDraggableMarker from '@/VueComponents/SharedComponents/Map/VueMapDraggableMarker.vue';
  import { MapMarkerStyle } from '@/VueComponents/SharedComponents/Map/Models/mapMarkerStyle';

  defineProps<{
    hideMarker?: boolean
  }>();

  const coordinate: Ref<MapCoordinate> = defineModel<MapCoordinate>('coordinate', { required: true });
  const cameraCoordinate: Ref<MapCoordinate> = defineModel<MapCoordinate>('cameraCoordinate', { required: true });
  const zoom: Ref<number> = defineModel<number>('zoom', { required: true });

  // Expose these refs to the test wrapper
  defineExpose({
    zoom,
    coordinate,
    cameraCoordinate
  });
  
</script>
<style scoped>
.camera-map {
  height: 385px;
}
</style>